export const environment = {
  production: true,
  buildNumber: 16,
  // app:'trilhaedu', //trilhaedu ou evotrilha
  app:'evotrilha',
  // appURLWEB: 'https://trilhaedu.app', //https://trilhaedu.app ou https://evotrilha.trilhaedu.app
  appURLWEB: 'https://evotrilha.trilhaedu.app',
  apiURL: 'https://api.netclass.trilhaedu.com.br/v1/mobile',
  relatnoauthURL: 'https://exemplo.trilhaedu.com.br/relatorios/prof-n/exercicio/v1-0',
  portalURL: 'https://portal.trilhaedu.com.br',
  targetDevice: 'web'
};

// export const environment = {
//   production: false,
//   buildNumber: 16,
//   // app: 'evotrilha',
//   app: 'trilhaedu',

//   appURLWEB: 'http://localhost:8100',

//   // apiURL: 'http://192.168.0.14:8081/v1/mobile',
//   // apiURL: 'http://localhost:8080/v1/mobile',
//   apiURL: 'http://localhost:8081/v1/mobile',
//   // apiURL: 'https://stg-api.netclass.trilhaedu.com.br/v1/mobile',
//   relatnoauthURL: 'https://webapp.trilhaedu.localhost/relatorios/prof-n/exercicio/v1-0',
//   // portalURL: 'http://localhost:4201',
//   // portalURL: 'http://192.168.0.14:4201',
//   portalURL: 'https://portal.trilhaedu.com.br',
//   // targetDevice: 'android'
//   targetDevice: 'web'
// };

// export const environment = {
//   production: false,
//   buildNumber: 14,
//   app: 'evotrilha',
//   // app: 'trilhaedu',

//   appURLWEB: 'http://localhost:8100',

//   // apiURL: 'http://192.168.0.14:8081/v1/mobile',
//   apiURL: 'http://10.80.45.188:8080/v1/mobile',
//   // apiURL: 'https://stg-api.netclass.trilhaedu.com.br/v1/mobile',
//   relatnoauthURL: 'https://webapp.trilhaedu.localhost/relatorios/prof-n/exercicio/v1-0',
//   // portalURL: 'http://localhost:4201',
//   // portalURL: 'http://192.168.0.14:4201',
//   portalURL: 'https://portal.trilhaedu.com.br',
//   targetDevice: 'android'
//   // targetDevice: 'web'
// };

// export const environment = {
//   production: false,
//   buildNumber: 10, 
//   // apiURL: 'http://192.168.0.186:8081/v1/mobile',
//   apiURL: 'http://localhost:8081/v1/mobile',
//   // apiURL: 'https://stg-api.netclass.trilhaedu.com.br/v1/mobile',
//   relatnoauthURL: 'https://webapp.trilhaedu.localhost/relatorios/prof-n/exercicio/v1-0',
//   // targetDevice: 'android'
//   targetDevice: 'web'
// };


// export const environment = {
//   production: false,
//   buildNumber: 7, 
//   // apiURL: 'http://192.168.43.11:8081/v1/mobile',
//   apiURL: 'http://localhost:8080/v1/mobile',
//   relatnoauthURL: 'https://webapp.trilhaedu.localhost/relatorios/prof-n/exercicio/v1-0',
//   targetDevice: 'web'
// };

// export const environment = {
//   production: true,
//   buildNumber: 6,
//   apiURL: 'https://api.netclass.trilhaedu.com.br/v1/mobile',
//   relatnoauthURL: 'https://exemplo.trilhaedu.com.br/relatorios/prof-n/exercicio/v1-0',
//   targetDevice: 'web'
// };

//juliana (alu), davi (prof) ,mariana (coord)